import { render, staticRenderFns } from "./abroadlogistics-add.vue?vue&type=template&id=6e2d7d14"
import script from "./abroadlogistics-add.vue?vue&type=script&lang=ts"
export * from "./abroadlogistics-add.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports